import { render, staticRenderFns } from "./CosmoClawChat.vue?vue&type=template&id=1b873c2f&scoped=true"
import script from "./CosmoClawChat.vue?vue&type=script&lang=js"
export * from "./CosmoClawChat.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawChat.vue?vue&type=style&index=0&id=1b873c2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b873c2f",
  null
  
)

export default component.exports